import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FooterComponent from "../footer";
import GetInTouchComponent from "../getInTouch";
import OurApproach from "../ourApproach";
import HeaderComponent from "../header";
import VisionMissionComponent from "./vision_mission";
import "../../styles/aboutUs/aboutUsStyles.scss";

const AboutUsComponent = ({ headerName, subHeaderName, ref }) => {
  const navigate = useNavigate();
  const refs = {
    Home: useRef(null),
    Services: useRef(null),
    "Case Studies": useRef(null),
    Blog: useRef(null),
    Contact: useRef(null),
    About: useRef(null),
  };

  const handleScrollToPortion = (section) => {
    if (section === "Contact" || section === "About") {
      refs[section]?.current?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  return (
    <>
      <HeaderComponent handleScrollToPortion={handleScrollToPortion} />
      <VisionMissionComponent />
      <OurApproach />
      <GetInTouchComponent ref={refs.Contact} />
      <FooterComponent
        handleScrollToPortion={handleScrollToPortion}
        ref={refs.About}
      />
    </>
  );
};

export default AboutUsComponent;
